module.exports = __webpack_public_path__ + "static/media/Intruded tooth 2.0321ca44.png";